import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const EndpointFilteringTableColumnsModel: ITableColumn[] = [
  {
    labelPath: 'policyPage.config.endpointFilteringContent.allowedEndpoints',
    propertyKey: 'endpoint',
    colType: TableColumnTypeEnum.Text,
    width: 40,
    widthType: WidthType.Percentage,
  },
  {
    labelPath: 'policyPage.config.endpointFilteringContent.protocol',
    propertyKey: 'protocol',
    colType: TableColumnTypeEnum.Text,
    width: 30,
    widthType: WidthType.Percentage,
  },
];
